import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const needs = ['A COMPLETE TRAINING SYSTEM.', 'CLEAR LABELED DIAGRAMS.', 'STEP-BY-STEP PROCEDURES.', '❌/✅ COMPARISONS.', 'READY SIMULATION SCENARIOS.', 'CLEAR COMPETENCY CRITERIA.', 'READY-TO-TEACH SESSIONS.', 'BETTER CLASS PREPARATION.'];
const alreadyHave = ['You already have the fundamentals, vital signs and patient care visuals.', 'You already have the anatomy, health assessment and examination sequences.', 'You already have the sterile technique, procedure and patient safety guides.', 'You already have the medication administration and dosage calculation methods.', 'You already have the med-surg, emergency response and clinical judgment frameworks.', 'You already have the lesson plans, simulation scenarios and competency assessments.'];
export function ClosingArgument() {
  return <section className="py-20 px-4 bg-white border-y border-slate-200" data-id="element-68" data-mp="1wcjn8dy7doh6">
      <motion.div initial={{
      opacity: 0,
      y: 16
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="max-w-3xl mx-auto text-center" data-id="element-69" data-mp="24vuygl8cf9on">
        <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-[#0B2545] mb-6 uppercase" data-id="element-70" data-mp="1v5ji1z7h380v">
          You Don&apos;t Need More Scattered <span className="text-[#0A7D79]" data-id="element-71" data-mp="1l7vlr4u7xsgl">Nursing Teaching Resources.</span>
        </h2>
        <p className="text-xl text-slate-700/80 mb-5" data-id="element-72" data-mp="1q6oz8x9i9jgr">You need:</p>
        <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2 mb-10" data-id="element-73" data-mp="1q803ey6v4t8e">
          {needs.map(need => <li key={need} className="text-lg md:text-xl font-extrabold text-[#0B2545] tracking-wide" data-id="element-74" data-mp="1c90h3x6toqfe">
              {need}
            </li>)}
        </ul>
        <div className="bg-[#F3F7FA] border border-slate-200 rounded-2xl p-8 text-lg text-slate-700 space-y-2 text-left sm:text-center" data-id="element-75" data-mp="36m9sxvmuco0t">
          <p className="mb-4" data-id="element-76" data-mp="3bhp42ftgs5tj">
            With NURSING INSTRUCTOR ATLAS, you don&apos;t start every session searching through textbooks, slide
            decks, videos and old notes.
          </p>
          {alreadyHave.map(line => <p key={line} className="text-[#0B2545] font-semibold flex items-center sm:justify-center gap-2" data-id="element-77" data-mp="303wutlfhu5w6">
              <Check size={18} className="text-[#0A7D79] shrink-0" aria-hidden="true" data-id="element-78" data-mp="2v7q06osjsgtj" />
              {line}
            </p>)}
          <p className="pt-4" data-id="element-79" data-mp="3ntr6hzo2toeu">
            And with the five exclusive bonuses, you also have nursing skills and vital signs flashcards, clinical
            skills demonstration lesson scripts, skills-lab and simulation drills, a dosage calculation practice
            workbook and nursing competency checklists, rubrics and certificates to help you plan, teach, correct
            and assess your students.
          </p>
          <p className="text-2xl md:text-3xl font-extrabold tracking-tight text-[#0B2545]" data-id="element-80" data-mp="ampodaynpvv6">
            YOU ALREADY HAVE <span className="text-[#0A7D79]" data-id="element-81" data-mp="i0713pbn8d6a">THE TRAINING FRAMEWORK.</span>
          </p>
        </div>
      </motion.div>
    </section>;
}